import React from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { VolunteerForm } from "@/components/forms/VolunteerForm";
import { HandHeart, GraduationCap, MapPin, Award } from "lucide-react";

export const VolunteerSection = () => (
  <section id="volunteer" className="surface-tint-green">
    <div className="container-wide py-16 lg:py-24">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHeader eyebrow="Volunteer" title="Give a little time. Change a lot of lives." lead="Join our founding network of 340+ volunteers. Choose a cause you love, work with our field teams, and grow through structured training." />
          <div className="grid grid-cols-2 gap-4 mt-2">
            {[[HandHeart, "Flexible commitment", "4 hours a month is enough"], [GraduationCap, "Real training", "Foundational + advanced tracks"], [MapPin, "Local + remote", "Field, comms, tech, research"], [Award, "Recognition", "Annual CAF Volunteer Awards"]].map(([Icon, t, d]) => (
              <div key={t} className="rounded-lg border border-[hsl(var(--border))] bg-card p-4">
                <div className="h-9 w-9 rounded-md bg-[hsl(var(--surface-tint-green))] text-[hsl(var(--green))] grid place-items-center"><Icon className="h-4.5 w-4.5" /></div>
                <div className="mt-3 font-semibold text-[hsl(var(--navy))] text-sm">{t}</div>
                <div className="text-xs text-[hsl(var(--muted-ink))] mt-1">{d}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-7">
          <Reveal><div className="rounded-xl border border-[hsl(var(--border))] bg-card p-6"><VolunteerForm /></div></Reveal>
        </div>
      </div>
    </div>
  </section>
);
